import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import Logo from './Logo';
import APP_CONFIG from '../config/appConfig';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language || 'en');
  const location = useLocation();
  const { currentUser, logout, loading } = useAuth();
  const { getCartItemCount } = useCart();
  const isAdminMode = APP_CONFIG.isAdminMode();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isAdminView = isAdminRoute && !!currentUser;

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    setLanguage(i18n.language || 'en');
  }, [i18n.language]);

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem('i18nextLng', lang);
  };

  const handleLogout = async () => {
    try {
      await logout();
      window.location.href = isAdminRoute ? '/admin/login' : '/';
    } catch (error) {
    }
  };

  return (
    <header className="bg-gray-900 shadow-lg sticky top-0 z-50 border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
    
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-9 h-9 bg-white rounded-full flex items-center justify-center">
              <Logo className="w-8 h-8" color="#7C3AED" />
            </div>
            <span className="text-2xl text-white script-font" style={{ fontSize: '2rem' }}>Visions Of Love</span>
          </Link>

         
          {isAdminView ? (
    
            <nav className="hidden md:flex space-x-8">
              <Link
                to="/admin/dashboard"
                className={`px-3 py-2 rounded-md text-sm font-medium uppercase transition-colors ${
                  isActive('/admin/dashboard') 
                    ? 'text-white bg-gray-800' 
                    : 'text-white hover:text-gray-300 hover:bg-gray-900'
                }`}
              >
                Dashboard
              </Link>
              <Link
                to="/admin/gallery"
                className={`px-3 py-2 rounded-md text-sm font-medium uppercase transition-colors ${
                  isActive('/admin/gallery') 
                    ? 'text-white bg-gray-800' 
                    : 'text-white hover:text-gray-300 hover:bg-gray-900'
                }`}
              >
                Manage Gallery
              </Link>
              <Link
                to="/admin/poetry"
                className={`px-3 py-2 rounded-md text-sm font-medium uppercase transition-colors ${
                  isActive('/admin/poetry') 
                    ? 'text-white bg-gray-800' 
                    : 'text-white hover:text-gray-300 hover:bg-gray-900'
                }`}
              >
                Manage Poetry
              </Link>
              <Link
                to="/admin/blogs"
                className={`px-3 py-2 rounded-md text-sm font-medium uppercase transition-colors ${
                  isActive('/admin/blogs') 
                    ? 'text-white bg-gray-800' 
                    : 'text-white hover:text-gray-300 hover:bg-gray-900'
                }`}
              >
                Manage Blogs
              </Link>
            </nav>
          ) : !isAdminRoute ? (
            <nav className="hidden md:flex space-x-8">
              <Link
                to="/"
                className={`px-3 py-2 rounded-md text-sm font-medium uppercase transition-colors ${
                  isActive('/') 
                    ? 'text-white bg-gray-800' 
                    : 'text-white hover:text-gray-300 hover:bg-gray-900'
                }`}
              >
                {t('header.home')}
              </Link>
              <Link
                to="/poetry"
                className={`px-3 py-2 rounded-md text-sm font-medium uppercase transition-colors ${
                  isActive('/poetry') 
                    ? 'text-white bg-gray-800' 
                    : 'text-white hover:text-gray-300 hover:bg-gray-900'
                }`}
              >
                {t('header.poetry')}
              </Link>
              <Link
                to="/blogs"
                className={`px-3 py-2 rounded-md text-sm font-medium uppercase transition-colors ${
                  isActive('/blogs') 
                    ? 'text-white bg-gray-800' 
                    : 'text-white hover:text-gray-300 hover:bg-gray-900'
                }`}
              >
                {t('header.blogs')}
              </Link>
              <Link
                to="/gallery"
                className={`px-3 py-2 rounded-md text-sm font-medium uppercase transition-colors ${
                  isActive('/gallery') 
                    ? 'text-white bg-gray-800' 
                    : 'text-white hover:text-gray-300 hover:bg-gray-900'
                }`}
              >
                {t('header.photos')}
              </Link>
              {/* SHOP DISABLED - Client request */}
              {/* <Link
                to="/shop"
                className={`px-3 py-2 rounded-md text-sm font-medium uppercase transition-colors ${
                  isActive('/shop') 
                    ? 'text-white bg-gray-800' 
                    : 'text-white hover:text-gray-300 hover:bg-gray-900'
                }`}
              >
                {t('header.shop')}
              </Link> */}
              <Link
                to="/contact"
                className={`px-3 py-2 rounded-md text-sm font-medium uppercase transition-colors ${
                  isActive('/contact') 
                    ? 'text-white bg-gray-800' 
                    : 'text-white hover:text-gray-300 hover:bg-gray-900'
                }`}
              >
                {t('header.contact')}
              </Link>
            </nav>
          ) : null}

          <div className="hidden md:flex items-center space-x-4">
            {/* SHOP DISABLED - Cart Icon hidden */}
            {/* <Link
              to="/cart"
              className="relative p-2 text-white hover:text-gray-300 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m8 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01" />
              </svg>
              {getCartItemCount() > 0 && (
                <span className="absolute -top-1 -right-1 bg-white text-black text-xs rounded-full h-5 w-5 flex items-center justify-center">
                  {getCartItemCount()}
                </span>
              )}
            </Link> */}

            {/* Language Toggle */}
            <div className="flex items-center space-x-2 border-l border-gray-700 pl-8 ml-2">
              <span className={`text-xs font-medium transition-colors ${language === 'en' ? 'text-white' : 'text-gray-400'}`}>
                English
              </span>
              <button
                onClick={() => handleLanguageChange(language === 'en' ? 'es' : 'en')}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-900 ${
                  language === 'es' ? 'bg-green-600' : 'bg-gray-600'
                }`}
              >
                <span
                  className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                    language === 'es' ? 'translate-x-6' : 'translate-x-1'
                  }`}
                />
              </button>
              <span className={`text-xs font-medium transition-colors ${language === 'es' ? 'text-white' : 'text-gray-400'}`}>
                Spanish
              </span>
            </div>

            {loading ? (
              <div className="w-20 h-8 bg-gray-800 rounded animate-pulse"></div>
            ) : currentUser ? (
              <div className="flex items-center space-x-6">
                <span className="text-white text-sm">
                  {t('header.welcome', { email: currentUser.email })}
                </span>
                <button
                  onClick={handleLogout}
                  className="px-3 py-2 text-white hover:text-gray-300 transition-colors text-sm"
                >
                  {t('header.logout')}
                </button>
                {/* Admin Dashboard button when in admin view */}
                {isAdminView && (
                  <Link
                    to="/admin/dashboard"
                    className="px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors text-sm whitespace-nowrap border border-white"
                  >
                    {t('header.adminDashboard')}
                  </Link>
                )}
              </div>
            ) : null}
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-md text-white hover:text-gray-300 hover:bg-gray-900"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-800">
            <nav className="flex flex-col space-y-2">
              {isAdminView ? (
                <>
                  <Link
                    to="/admin/dashboard"
                    className={`px-3 py-2 rounded-md text-sm font-medium uppercase ${
                      isActive('/admin/dashboard') ? 'text-white bg-gray-800' : 'text-white'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Dashboard
                  </Link>
                  <Link
                    to="/admin/gallery"
                    className={`px-3 py-2 rounded-md text-sm font-medium uppercase ${
                      isActive('/admin/gallery') ? 'text-white bg-gray-800' : 'text-white'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Manage Gallery
                  </Link>
                  <Link
                    to="/admin/poetry"
                    className={`px-3 py-2 rounded-md text-sm font-medium uppercase ${
                      isActive('/admin/poetry') ? 'text-white bg-gray-800' : 'text-white'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Manage Poetry
                  </Link>
                  <Link
                    to="/admin/blogs"
                    className={`px-3 py-2 rounded-md text-sm font-medium uppercase ${
                      isActive('/admin/blogs') ? 'text-white bg-gray-800' : 'text-white'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Manage Blogs
                  </Link>
                </>
              ) : !isAdminRoute ? (
                <>
                  <Link
                    to="/"
                    className={`px-3 py-2 rounded-md text-sm font-medium uppercase ${
                      isActive('/') ? 'text-white bg-gray-800' : 'text-white'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {t('header.home')}
                  </Link>
                  <Link
                    to="/poetry"
                    className={`px-3 py-2 rounded-md text-sm font-medium uppercase ${
                      isActive('/poetry') ? 'text-white bg-gray-800' : 'text-white'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {t('header.poetry')}
                  </Link>
                  <Link
                    to="/blogs"
                    className={`px-3 py-2 rounded-md text-sm font-medium uppercase ${
                      isActive('/blogs') ? 'text-white bg-gray-800' : 'text-white'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {t('header.blogs')}
                  </Link>
                  <Link
                    to="/gallery"
                    className={`px-3 py-2 rounded-md text-sm font-medium uppercase ${
                      isActive('/gallery') ? 'text-white bg-gray-800' : 'text-white'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {t('header.photos')}
                  </Link>
                  {/* SHOP DISABLED - Client request */}
                  {/* <Link
                    to="/shop"
                    className={`px-3 py-2 rounded-md text-sm font-medium uppercase ${
                      isActive('/shop') ? 'text-white bg-gray-800' : 'text-white'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {t('header.shop')}
                  </Link> */}
                  <Link
                    to="/contact"
                    className={`px-3 py-2 rounded-md text-sm font-medium uppercase ${
                      isActive('/contact') ? 'text-white bg-gray-800' : 'text-white'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {t('header.contact')}
                  </Link>
                  {/* SHOP DISABLED - Cart link hidden */}
                  {/* <Link
                    to="/cart"
                    className={`px-3 py-2 rounded-md text-sm font-medium flex items-center space-x-2 uppercase ${
                      isActive('/cart') ? 'text-white bg-gray-800' : 'text-white'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.5 5M7 13l2.5 5m6-5v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m8 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01" />
                    </svg>
                    <span>{t('header.cart')}</span>
                    {getCartItemCount() > 0 && (
                      <span className="bg-white text-black text-xs rounded-full h-5 w-5 flex items-center justify-center">
                        {getCartItemCount()}
                      </span>
                    )}
                  </Link> */}
                </>
              ) : null}
              
              {/* Language Toggle - Mobile */}
              <div className="flex items-center justify-between px-3 py-2 border-t border-gray-800">
                <span className={`text-sm font-medium transition-colors ${language === 'en' ? 'text-white' : 'text-gray-400'}`}>
                  English
                </span>
                <button
                  onClick={() => handleLanguageChange(language === 'en' ? 'es' : 'en')}
                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-900 ${
                    language === 'es' ? 'bg-green-600' : 'bg-gray-600'
                  }`}
                >
                  <span
                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                      language === 'es' ? 'translate-x-6' : 'translate-x-1'
                    }`}
                  />
                </button>
                <span className={`text-sm font-medium transition-colors ${language === 'es' ? 'text-white' : 'text-gray-400'}`}>
                  Spanish
                </span>
              </div>
              
              <div className="pt-4 border-t border-gray-800">
                {loading ? (
                  <div className="w-full h-8 bg-gray-800 rounded animate-pulse"></div>
                ) : currentUser ? (
                  <div className="flex flex-col space-y-3">
                    <span className="text-white px-3 py-2 text-sm">
                      {t('header.welcome', { email: currentUser.email })}
                    </span>
                    <div className="flex flex-col space-y-2">
                      <button
                        onClick={() => {
                          handleLogout();
                          setIsMenuOpen(false);
                        }}
                        className="px-3 py-2 text-white hover:text-gray-300 text-sm"
                      >
                        {t('header.logout')}
                      </button>
                      {isAdminView && (
                        <Link
                          to="/admin/dashboard"
                          className="px-3 py-2 bg-gray-800 text-white rounded-lg text-center text-sm border border-white"
                          onClick={() => setIsMenuOpen(false)}
                        >
                          {t('header.adminDashboard')}
                        </Link>
                      )}
                    </div>
                  </div>
                ) : null}
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
